import { Routes } from '@angular/router';
import {SwiperComponent} from "./calendar/swiper/swiper.component";
import {NoteComponent} from "./note/note.component";
import {DebugSentryComponent} from "./utils/debug-sentry/debug-sentry.component";
import moment from 'moment';
import {AdminComponent} from "./admin/admin/admin.component";
import {LoginComponent} from "./auth/login/login.component";
import {PageNotFoundComponent} from "./errors/page-not-found/page-not-found.component";
import {authGuard} from "./auth/auth.guard";
import {SpinnerComponent} from "./utils/spinner/spinner.component";
import {ForgotPasswordComponent} from "./auth/forgot-password/forgot-password.component";
import {ChangePasswordComponent} from "./auth/change-password/change-password.component";
import {BlockListComponent} from "./admin/block-list/block-list.component";

// Funzione per ottenere la data corrente nel formato dd-mm-yyyy
function getCurrentDate(): string {
  return moment().format('YYYY-MM-DD');
}

export const routes: Routes = [
  //Route applicative protette dall'autenticazione
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [authGuard] },
  { path: 'calendario/:day', component: SwiperComponent, canActivate: [authGuard] },
  { path: 'admin/:day', component: AdminComponent, canActivate: [authGuard] },
  { path: 'note/:day', component: NoteComponent, canActivate: [authGuard] },
  { path: 'block-list', component: BlockListComponent, canActivate: [authGuard]},

  // Redirect
  { path: 'calendario', redirectTo: `/calendario/${getCurrentDate()}`, pathMatch: 'full'},


  // Route per la gestione della login
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: '', redirectTo: `/login`, pathMatch: 'full'},

  //Utils
  { path: 'loading', component: SpinnerComponent },

  // Route per il debug di Sentry
  { path: 'debug-sentry', component: DebugSentryComponent, canActivate: [authGuard] },

  // Route per la gestione degli errori
  { path: '**', component: PageNotFoundComponent },

];
